import NotificationActions from 'actions/Notification'
import { InputSearch } from 'components/InputSearch'
import { InputSelect } from 'components/InputSelect'
import NavNotifications, { NavItems } from 'pages/Notifications/Nav'
import { notificationOrder } from 'constants/notificationOrder'
import { notificationSubStateOptions, findNavbarItemBySubState } from 'constants/notificationSubState'
import { useEffect, useMemo, useRef, useState } from 'react'
import { Control, FieldValues } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { IAuthenticationReducer } from 'types/autentication'
import { RootReducerState } from 'types/global'
import { NotificationAction, NotificationReducer } from 'types/notification'
import {
    FilterContainer,
    HeaderContainer,
    StatusNotifications,
    TitleNotifications,
    Top,
    TopInputs
} from './styles'

interface HeaderProps {
    control: Control<FieldValues, any>
    setCurrentNavItems: Function
    currentLocationList: any[]
    currentSectorList: any[]
    currentDamageLevelList: any[]
    notificationsList: any[]
    tabNavItems: NavItems[]
    isEnabledLocationFilter: boolean
    isEnabledSectorFilter: boolean
    handleFilterWithSearch: any
    onChangeLocation?: any
    onChangeSector?: any
    onChangeOrder?: any
    onChangeDamageLevel?: any
    onChangeSubState?: any
    onChangeSysCreatedBy?: any
    setCurrentNav: React.Dispatch<React.SetStateAction<NavItems>>
    currentNav: NavItems
    selectAll?: any
    subState?: string
}


export const notificationsStatusText = (currentNav: NavItems, notificationsList: any[], subState?: string, notificationScreen?: any) => {
    if (currentNav) {
        let displayNumber = currentNav.number
        
        // Se estiver na aba de Finalizados (id 5) e houver filtro de subState,
        // buscar o contador correto do backend usando o u_sub_state
        if (currentNav.id === 5 && subState && subState !== '' && notificationScreen?.navbar) {
            const finishedNavItem = findNavbarItemBySubState(notificationScreen.navbar, 5, subState)
            
            if (finishedNavItem && finishedNavItem.number) {
                displayNumber = finishedNavItem.number
            }
        }
        
        switch (currentNav.id) {
            case 1:
                let notificationRead =
                    notificationsList &&
                    notificationsList.filter(
                        (notification) =>
                            notification.u_notification_read.value ===
                            'false'
                    )
                return `${displayNumber} Notificações novas / ${notificationRead?.length} Não lidas`
            case 2:
                return `${displayNumber} Notificações aguardando tratamento`
            case 3:
                return `${displayNumber} Notificações em tratamento`
            case 4:
                return `${displayNumber} Notificações pendentes`
            case 5:
                return `${displayNumber} Notificações finalizadas`
            case 6:
                return `${displayNumber} Notificações arquivadas`
            case 7:
                return `${displayNumber} Notificações em seu nome`
            case 8:
                return `${displayNumber} Notificações`
        }
    }
}

function HeaderNotifications({
    control,
    tabNavItems,
    setCurrentNavItems,
    setCurrentNav,
    currentNav,
    currentLocationList,
    currentSectorList,
    currentDamageLevelList,
    notificationsList,
    isEnabledLocationFilter,
    isEnabledSectorFilter,
    handleFilterWithSearch,
    onChangeLocation,
    onChangeOrder,
    onChangeSector,
    onChangeDamageLevel,
    onChangeSubState,
    onChangeSysCreatedBy,
    selectAll,
    subState
}: HeaderProps) {
    const [navItems, setNavItems] = useState<NavItems[]>(tabNavItems)
    const [searchValue, setSearchValue] = useState<string>(undefined)
    const prevValue = useRef('')

    const handleFilterWithSearchLocal = (event: any) => {
        prevValue.current = searchValue
        handleFilterWithSearch(event)
    }

    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )

    const handleCleanInputSearch = () => {
        setSearchValue('')
        handleFilterWithSearch({ type: 'blur', target: { value: '' } })
    }

    const notificationDispatch: Dispatch<NotificationAction> =
        useDispatch()

    const auth: IAuthenticationReducer = useSelector((state: RootReducerState) => state.authenticationReducers)

    useEffect(() => {
        if (!currentNav) return
        
        setCurrentNavItems(currentNav)
        /** Enviado item de navegação na tela de notificações para o Redux */
        // Só atualiza o Redux se for diferente do valor atual
        if (!notificationSelector.currentNavItem || 
            notificationSelector.currentNavItem.id !== currentNav.id) {
            NotificationActions.setCurrentNavItem(notificationDispatch, currentNav)
        }
    }, [currentNav])


    useEffect(() => {
        setNavItems(tabNavItems)
        let screen = notificationSelector.notificationScreen;
        const haveAll = screen?.navbar?.filter(i => i?.name == 'Todas').length > 0
        const searchResultCount = screen?.list_notifications?.length ?? 0
        if (haveAll && searchValue && searchResultCount !== 1) {
            let totalNotifications = screen?.navbar?.map(i => Number(i?.number || 0)).reduce((acc, curr) => acc + curr, 0) / 2
            if (totalNotifications > 1 && JSON.stringify(tabNavItems) != JSON.stringify(navItems)) {
                setCurrentNav(tabNavItems[tabNavItems.length - 1])
            }
        }
    }, [tabNavItems])

    return (
        <HeaderContainer>
            <div className="mx-8 mt-8 mb-5 w-full flex flex-row justify-between">
                <div className="flex flex-row gap-4">
                    <div>
                        <InputSelect
                            unitText="Ordenar por"
                            defaultValue={notificationOrder[1].value}
                            searchPlaceHolder="Buscar"
                            onChange={onChangeOrder}
                            styleBoxOptions="mt-3 w-[180px]"
                            styleContainer="w-[180px]"
                            label="Ordenar por"
                            name="order"
                            control={control}
                            data={notificationOrder}
                            placeholder={"Selecionar"}
                        />
                    </div>
                    <div>
                        <InputSelect
                            multiUnitText="Classificações selecionadas"
                            unitText="Classificação selecionada"
                            onChange={onChangeDamageLevel}
                            defaultValue={[]}
                            allIsSelected={true}
                            multiple={true}
                            searchPlaceHolder="Buscar"
                            shouldHaveSearch={true}
                            styleBoxOptions="mt-3 w-[300px]"
                            styleContainer="w-[180px]"
                            label="Classificação do Incidente"
                            name="damageLevel"
                            control={control}
                            data={currentDamageLevelList}
                            placeholder="Todos"
                            selectAll={selectAll}
                        />
                    </div>
                    <div>
                        <InputSelect
                            required={true}
                            styleBoxOptions="mt-3 w-[360px]"
                            styleContainer="w-[180px]"
                            label="Aberto por"
                            name="u_user_type"
                            control={control}
                            data={[
                                { value: 'u_patient', label: 'Paciente' },
                                { value: 'u_employee', label: 'Administrativo' }
                            ]}
                            defaultValue={null}
                            placeholder='Todos'
                            onChange={onChangeSysCreatedBy}
                        />
                    </div>
                    {currentNav?.id === 5 && (
                        <div>
                            <InputSelect
                                unitText="Sub Status"
                                onChange={onChangeSubState}
                                defaultValue=""
                                searchPlaceHolder="Buscar"
                                styleBoxOptions="mt-3 w-[220px]"
                                styleContainer="w-[180px]"
                                label="Sub Status"
                                name="subState"
                                control={control}
                                data={notificationSubStateOptions}
                                placeholder="Todos"
                            />
                        </div>
                    )}
                </div>
                <div className="mr-[64px] self-end md:w-[600px] w-full md:mt-4">
                    <InputSearch
                        handleCleanInputSearch={handleCleanInputSearch}
                        searchValue={searchValue}
                        value={searchValue || ''}
                        name="search"
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyUp={handleFilterWithSearchLocal}
                        onBlur={handleFilterWithSearchLocal}
                        className="w-full"
                        placeholder="Buscar"
                    />
                </div>
            </div>

            <div className="xl:mx-0 mr-8">
                <NavNotifications
                    currentNav={currentNav}
                    setCurrentNav={setCurrentNav}
                    navItems={navItems}
                />
            </div>

            <FilterContainer>
                <div className="flex flex-wrap">
                </div>

                <StatusNotifications>
                    {notificationsStatusText(currentNav, notificationsList, subState, notificationSelector.notificationScreen)}
                </StatusNotifications>
            </FilterContainer>
        </HeaderContainer>
    )
}

export { HeaderNotifications }

